"use strict";
/**
 * @fileoverview Order request types for REST API
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliverySettlementStatus = exports.PaymentStatus = exports.AmountBasis = exports.OrderSort = void 0;
var SearchOrdersRequest_js_1 = require("./SearchOrdersRequest.js"); // Export enums as values
Object.defineProperty(exports, "OrderSort", { enumerable: true, get: function () { return SearchOrdersRequest_js_1.OrderSort; } });
Object.defineProperty(exports, "AmountBasis", { enumerable: true, get: function () { return SearchOrdersRequest_js_1.AmountBasis; } });
Object.defineProperty(exports, "PaymentStatus", { enumerable: true, get: function () { return SearchOrdersRequest_js_1.PaymentStatus; } });
Object.defineProperty(exports, "DeliverySettlementStatus", { enumerable: true, get: function () { return SearchOrdersRequest_js_1.DeliverySettlementStatus; } });
